import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const generalDocumentKindsOptions = [
  { label: 'Documento de qualificação', value: 'qualification_document' },
  { label: 'Contrato do estabelecimento', value: 'establishment_contract' },
]

export const generalDocumentKinds = optionsToStrategy(generalDocumentKindsOptions)
